export const CHANGE_FILTERS = 'CHANGE_FILTERS'